// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-checkbox{margin:.5rem 0}.dropdown-menu{min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content}.custom-radio{margin:.5rem 0}", ""]);
// Exports
module.exports = exports;
